import eventBus from "@sd-utility/eventbus";

const MODAL_REGEX = /^modal\//;

const getEventHandler = (event?: string) => {
  if (!event || !MODAL_REGEX.test(event)) return;
  return () => eventBus.publish("modal/open", event);
};

export default getEventHandler;
